import { render, staticRenderFns } from "./InfoPoint.vue?vue&type=template&id=577b0a02&scoped=true&"
import script from "./InfoPoint.vue?vue&type=script&lang=ts&"
export * from "./InfoPoint.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPoint.vue?vue&type=style&index=0&id=577b0a02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b0a02",
  null
  
)

export default component.exports